import {
    IconApiApp,
    IconBook,
    IconBrandDiscord,
    IconBrandDocker, IconBrandFigma,
    IconBrandGithub,
    IconBrandGraphql,
    IconBrandHtml5,
    IconBrandJavascript,
    IconBrandMantine,
    IconBrandMongodb, IconBrandNextjs,
    IconBrandPrisma,
    IconBrandReact,
    IconBrandTypescript, IconBrandVercel,
    IconBrandVite,
    IconBrandYoutube, IconExternalLink, IconGraph,
    IconHtml,
    IconRobot,
    IconTerminal,
    IconTransferIn
} from "@tabler/icons-react";

export const dataProject = [
    {
        title: "Arcane redesign",
        description: "Site fictif de l'arrivée de la nouvelle saison d'Arcane, la série de Riot Games.",
        tags: [
            {
                title:"NextJS",
                icon: <IconBrandNextjs width={20} height={20}/>
            },
            {
                title:"Vercel",
                icon: <IconBrandVercel width={20} height={20}/>
            },
        ],
        detailsProjects: {
            color: "#dc321e",
            context: "ArcaneV4 est un site promotionnel dédié à la nouvelle série Arcane, inspirée de l’univers du jeu League of Legends. Ce site a pour but de captiver les fans et de les plonger dans l’univers sombre et stylisé de la série. Il présente le pitch de Arcane, la bande-annonce, et redirige les visiteurs vers les plateformes de streaming. Conçu pour les 15-35 ans, le site pourrait inclure un compte à rebours pour les prochaines diffusions et proposer des produits dérivés pour renforcer l’engagement des fans.<br/>",
            technologieUsed: [
                {
                    title: "NextJS",
                    icon: <IconApiApp width={20} height={20}/>
                },
                {
                    title: "Vercel",
                    icon: <IconBrandVercel width={20} height={20}/>
                },
            ],
            links: [
                {
                    icon: <IconExternalLink width={20} height={20}/>,
                    title: "Lien du site",
                    src: "https://arcanev4.vercel.app/"
                },
                {
                    icon: <IconBrandFigma width={20} height={20}/>,
                    title: "Figma",
                    src: "https://www.figma.com/proto/mmDC4AcwnmyBX9EJ4oBFcF/BOTW?page-id=4683%3A567&node-id=4695-1874&node-type=frame&viewport=923%2C1074%2C0.19&t=rl6MCOySza3visC4-1&scaling=min-zoom&content-scaling=fixed"
                },
            ],
            carousel: ["assets/portfolio/arcane/carousel1.png","assets/portfolio/arcane/carousel2.png","assets/portfolio/arcane/carousel3.png","assets/portfolio/arcane/carousel4.png","assets/portfolio/arcane/carousel5.png"],
        },
        image: "assets/portfolio/arcane/carousel1.png",
        language: [<IconTerminal />],

        tagSelected: ['all', 'Web App']
    },
    {
        title: "New Leaf",
        description: "Site fictif de promotion d'une tournée mondiale d'un artiste fictif jouant du Ghuzeng (instrument traditionnel chinois).",
        tags: [
            {
                title:"NextJS",
                icon: <IconBrandNextjs width={20} height={20}/>
            },
            {
                title:"Vercel",
                icon: <IconBrandVercel width={20} height={20}/>
            },
        ],
        detailsProjects: {
            color: "#dc321e",
            context: "New Leaf, formé en 2019, est un groupe fictif, dont le genre musical (à définir) inspire le design du site. Ce projet est une création personnelle qui vise à capturer l'essence du groupe tout en servant de vitrine pour promouvoir leur tournée mondiale.<br/> Destiné aux 20-35 ans, le site doit être attractif, international et accessible, avec un compte à rebours dynamique pour créer de l’anticipation autour du premier concert. La direction artistique est libre, encourageant l'originalité pour mieux refléter l'identité unique de New Leaf et offrir une expérience immersive à leurs fans.<br/>",
            technologieUsed: [
                {
                    title: "NextJS",
                    icon: <IconApiApp width={20} height={20}/>
                },
                {
                    title: "Vercel",
                    icon: <IconBrandVercel width={20} height={20}/>
                },
            ],
            links: [
                {
                    icon: <IconExternalLink width={20} height={20}/>,
                    title: "Lien du site",
                    src: "https://new-leaf-concert.vercel.app/"
                },
                {
                    icon: <IconBrandFigma width={20} height={20}/>,
                    title: "Figma",
                    src: "https://www.figma.com/proto/CbQlCObFgPoPhL9fLmnTgZ/New-Leaf---Guzheng-Tour?page-id=0%3A1&node-id=12-2&node-type=frame&viewport=508%2C611%2C0.34&t=X2B6n0F96hskgZ5q-1&scaling=min-zoom&content-scaling=fixed"
                },
            ],
            carousel: ["assets/portfolio/new-leaf/carousel1.png","assets/portfolio/new-leaf/carousel2.png","assets/portfolio/new-leaf/carousel3.png","assets/portfolio/new-leaf/carousel4.png","assets/portfolio/new-leaf/carousel5.png","assets/portfolio/yams/carousel6.png"],
        },
        image: "assets/portfolio/new-leaf/carousel1.png",
        language: [<IconTerminal />],
        tagSelected: ['all', 'Web App']
    },
    {
        title: "Jeu de Yams",
        description: "Développement d'un jeu de Yams avec le framework JavaSpring et implémentation d'IA intelligente",
        tags: [
            {
                title:"Java Spring",
                icon: <IconApiApp width={20} height={20}/>
            },
            {
                title:"Docker",
                icon: <IconBrandDocker width={20} height={20}/>
            },
            {
                title: "...",
            }
        ],
        detailsProjects: {
            color: "#f27059",
            context: "Le but de ce projet était de créer un jeu de Yams en utilisant le framework javaspring.<br/><br/>" +
                "<u>Les règles du jeu : </u><br/>" +
                "Le Yahtzee est un jeu de dés où le but est de marquer autant de points que possible en remplissant différentes combinaisons sur une feuille de score. Le jeu est joué avec cinq dés, et une feuille de score.",
            technologieUsed: [
                {
                    title: "Java Spring",
                    icon: <IconApiApp width={20} height={20}/>
                },
                {
                    title: "Docker",
                    icon: <IconBrandDocker width={20} height={20}/>
                },
                {
                    title: "Github - Gestion de projet",
                    icon: <IconBrandDocker width={20} height={20}/>
                },
                {
                    title: "Travis - Intégration continue",
                    icon: <IconTransferIn width={20} height={20}/>
                },
                {
                    title: "IA intelligente",
                    icon: <IconRobot width={20} height={20}/>
                },
                {
                    title: "Méthode Agile",
                    icon: <IconBrandGithub width={20} height={20}/>
                }
            ],
            links: [
                {
                    icon: <IconBrandYoutube width={20} height={20}/>,
                    title: "Youtube",
                    src: "https://youtu.be/IbL_IDWkynU"
                },
            ],
            carousel: ["assets/portfolio/yams/carousel1.png","assets/portfolio/yams/carousel2.png","assets/portfolio/yams/carousel3.png","assets/portfolio/yams/carousel4.png","assets/portfolio/yams/carousel5.png","assets/portfolio/yams/carousel6.png"],
            description: "Pour un projet universitaire, j'ai été amené à développer un jeu de Yams. Le but étant de découvrir et de manier le framework javaspring et notamment apprendre l'utilisation de docker.<br/>" +
                "La réalisation du projet s'est opérée selon la méthode agile, mobilisant une équipe de 5 personnes. Nous avons opté pour la méthode Scrum, découpant le travail en sprints de 3 semaines, " +
                "et avons utilisé la plateforme Github pour la gestion des tâches et des sprints. " +
                "En complément, Travis, un logiciel d'intégration continue (non nativement implémenté sur Github comme c'est le cas sur GitLab), a été intégré." +
                "<br/>" +
                "Ce projet, axé sur une interface en ligne de commande sans éléments visuels frontaux, a tiré parti de l'utilisation de Docker pour la gestion des conteneurs. Cette approche a permis le lancement simultané de plusieurs parties, avec la possibilité pour plusieurs joueurs de participer en même temps. " +
                "Une salle d'attente a été mise en place pour permettre aux joueurs d'attendre la création d'une partie et de la rejoindre ultérieurement. " +
                "En outre, des joueurs virtuels dotés d'une intelligence artificielle ont été intégrés, utilisant des algorithmes de probabilités et de statistiques pour déterminer les meilleurs coups à jouer."
        },
        image: "assets/portfolio/yams/jeu_yams.jpg",
        language: [<IconTerminal />],
        tagSelected: ['all', 'java']
    },
    {
        title: "Prompt ChatGPT - Custom",
        description: "Développement d'un prompt qui reprend le modèle de chatGPT avec des fonctionnalités supplémentaires. Possibilité de générer des images, de retranscrire à l'écrit des sons, de résumer un texte, d'avoir des varations d'images à partir d'une image de base...",
        tags: [
            {
                title:"Javascript",
                icon: <IconBrandJavascript width={20} height={20}/>
            },
            {
                title:"API openAI",
                icon: <IconApiApp width={20} height={20}/>
            },
            {
                title:"...",
            }
        ],
        detailsProjects: {
            color: "#84dcc6",
            context: "C'est un petit projet pour apprendre les bases de l'IA.\n" +
                "Le but de ce projet est d'utiliser les fonctionnalités disponible de OpenAI et de faire notre propre chatGPT.\n",
            technologieUsed: [
                {
                    title: "NodeJS",
                    icon: <IconApiApp width={20} height={20}/>
                },
                {
                    title: "API OpenAI",
                    icon: <IconBrandDocker width={20} height={20}/>
                },
                {
                    title: "HTML/CSS",
                    icon: <IconBrandHtml5 width={20} height={20}/>
                },
            ],
            carousel: ["assets/portfolio/prompt-gpt/carousel1.png","assets/portfolio/prompt-gpt/carousel2.png","assets/portfolio/prompt-gpt/carousel3.png","assets/portfolio/prompt-gpt/carousel4.png"],
            description: "Dans le cadre de mes études, j'ai développé en groupe de 2 un prompt à la chatGPT avec des fonctionnalités supplémentaires. Le but était de découvrir et de voir ses possibilités. Nous avons utilisé l'API de OpenAI pour faire notre prompt :<br/><ul>" +
                "<li>- Génération d'image à partir d'une image de base</li>" +
                "<li>- Génération d'image à partir d'un texte</li>" +
                "<li>- On peut demander à l'ia quelque chose et nous répondre avec une voix</li>" +
                "<li>- Nous résumer un texte (un texte en anglais et nous le traduire en français par exemple)</li>" +
                "<li>- On peut aussi lui envoyer une image de base et lui demander des images dans le même thème mais générer.</li></ul>"+
                "L'objectif était de travailler avec l'API de OpenAI et d'adapter la requête. Nous avons aussi fait une interface graphique pour pouvoir utiliser le prompt plus facilement. Et un système d'historique pour pouvoir retourner sur les requêtes précédentes."
        },
        image: "assets/portfolio/prompt-gpt/prompt_gpt.jpg",
        language: [<IconBrandReact />],
        tagSelected: ['all', 'web']
    },
    {
        title: "Bot Discord",
        description: "Développement d'un bot discord en NodeJS avec la librairie Discord.JS pour le serveur discord Mantaria Studio. Ce serveur avait un besoin d'automatiser de la création d'un ticket pour des clients jusqu'au suivi de la commande entre le client et le prestataire, et d'autres encore...",
        tags: [
            {
                title:"NodeJS",
                icon: <IconBrandJavascript width={20} height={20}/>
            },
            {
                title:"Lib discord.js",
                icon: <IconBook width={20} height={20}/>
            },
            {
                title:"...",
            }
        ],
        detailsProjects: {
            color: "#a2d2ff",
            context: "Ce fut un projet long terme.<br/>" +
                "Étant co-fondateur mais aussi, responsable technique chez Mantaria Studio. J'ai donc réalisé avec un autre responsable Remy, un bot discord pour répondre à nos besoins.<br/>",
            technologieUsed: [
                {
                    title: "NodeJS",
                    icon: <IconBrandJavascript width={20} height={20}/>
                },
                {
                    title: "Lib DiscordJS",
                    icon: <IconBook width={20} height={20}/>,
                    link: "https://old.discordjs.dev/#/docs/discord.js/main/general/welcome"
                },
                {
                    title: "MongoDB - BD NoSQL",
                    icon: <IconBrandMongodb width={20} height={20}/>
                },
            ],
            links: [
                {
                    icon: <IconBrandDiscord width={20} height={20}/>,
                    title: "Discord",
                    src: "https://discord.com/invite/ywmYrQ9Bbm"
                },
            ],
            carousel: ["assets/portfolio/bot-discord/carousel1.png", "assets/portfolio/bot-discord/carousel2.png","assets/portfolio/bot-discord/carousel3.png","assets/portfolio/bot-discord/carousel4.png","assets/portfolio/bot-discord/carousel5.png"],
            description: "Nous avions un besoin de réaliser un bot qui serait capable d'automatiser la création de ticket pour nos clients. Mais aussi, de pouvoir suivre la commande entre le client et le prestataire. Le but étant d'avoir une interface assez simple et facile d'utilisation.<br/>"+
            "Nous avions plusieurs phases : <br/>" +
                "<ul>" +
                "<li>- Phase 1 : Création d'un ticket + discussion avec le client pour connaître précisement le besoin</li>" +
                "<li>- Phase 2 : Création d'un devis + discussion avec le client pour valider le devis</li>" +
                "<li>- Phase 3 : Création d'une facture découpée en 2 acomptes (50% au début et 50% à la fin)</li>" +
                "<li>- Phase 4 : Suivi de la commande entre le client et le prestataire</li>" +
                "<li>- Phase 5 : Le client paie et émet un avis pour sa prestation.</li>" +
                "</ul>"+
                "Tout cela accompagné par des boutons et des automatisations (Etat du ticket, les discussions qu'il y a eu...etc) pour le prestataire et surtout pour nous (afin d'avoir un suivi précis de la commande)<br/>"+
                "Nous avons aussi ajouté des fonctionnalités supplémentaires comme : <br/>" +
                "<ul>" +
                "<li>- Affichage de nos prestataires </li>" +
                "<li>- Affichage des règles, nos prix, à propos de nous...</li>" +
                "<li>- Affichage des avis de nos clients</li>",
        },
        image: "assets/portfolio/bot-discord/bot_discord.jpg",
        language: [<IconBrandReact />],
        tagSelected: ['all', 'web']
    },
    {
        title: "Dashboard - Mantaria Studio",
        description: "Développement d'un dashboard pour la gestion de l'entreprise Mantaria Studio. Ce dashboard permet de gérer les tickets, les prestataires, les clients, les devis, les factures, les commandes, et faire des statistiques sur les données.",
        tags: [
            {
                title:"React - ViteJS",
                icon: <IconBrandVite width={20} height={20}/>
            },
            {
                title:"Prisma",
                icon: <IconBrandPrisma width={20} height={20}/>
            },
            {
                title:"...",
            }
        ],
        detailsProjects: {
            color: "#9381ff",
            context: "L'objectif de ce projet était de pouvoir visualiser mais aussi, de pouvoir gérer les données (ajouter, modifier, supprimer) de l'entreprise Mantaria Studio.<br/>" +
                "Cette application est destiné aux prestataires de notre équipe ainsi qu'aux responsables de ceux-ci. Elle est donc privée et n'est pas accessible au public.<br/>",
            technologieUsed: [
                {
                    title: "React - ViteJS",
                    icon: <IconBrandVite width={20} height={20}/>
                },
                {
                    title: "TypeScript",
                    icon: <IconBrandTypescript width={20} height={20}/>
                },
                {
                    title: "Prisma",
                    icon: <IconBrandPrisma width={20} height={20}/>,
                    link: "https://www.prisma.io/"
                },
                {
                    title: "Express JS",
                    icon: <IconBrandJavascript width={20} height={20}/>
                },
                {
                    title: "Mantine - Librairie UI",
                    icon: <IconBrandMantine width={20} height={20}/>,
                    link: "https://mantine.dev/"
                },
                {
                    title: "Tremor - Librairie Graph",
                    icon: <IconGraph width={20} height={20}/>,
                    link: "https://www.tremor.so/"
                },
                {
                    title: "MongoDB - BD NoSQL",
                    icon: <IconBrandMongodb width={20} height={20}/>,
                },
            ],
            links: [
                {
                    icon: <IconBrandDiscord width={20} height={20}/>,
                    title: "Discord",
                    src: "https://discord.com/invite/ywmYrQ9Bbm"
                },
            ],
            carousel: ["assets/portfolio/dashboard/carousel1.png","assets/portfolio/dashboard/carousel2.png","assets/portfolio/dashboard/carousel3.png","assets/portfolio/dashboard/carousel4.png"],
            description: "Nous avons donc établi un outil pratique et ergonomique pour gérer les facturations, les transactions, les commandes...etc. Pouvoir avoir une visualisation un peu externe de discord et plus globale.<br/>"+
                "Nous avons utilisé plusieurs librairies et outils afin de réaliser cette application :" +
                "<div class='container-card'>" +
                "<div class='card'><span class='title'>Mantine - Librairie UI</span>la librairie Mantine pour le design de l'application, elle implemente plein de composants utiles, rapide et efficace pour le développement.</div>" +
                "<div class='card'><span class='title'>Tremor - Librairie Graph</span>la librairie Tremor pour les graphiques, elle implémente la lib chartJS (une lib connue pour les graphiques) </div>" +
                "<div class='card'><span class='title'>Prisma</span>la librairie Prisma pour le schéma de base de donnée, elle permet de faire le lien entre la base de donnée et l'application. Elle permet aussi de faire des requêtes plus facilement.</div>" +
                "<div class='card'><span class='title'>MongoDB - BD NoSQL</span>la base de donnée MongoDB, une base de donnée NoSQL, qui est très pratique pour les applications web. Elle est très rapide et efficace.</div>" +
                "</div>"+
                "Comme vous pouvez le voir sur les screens ci-joint, la page d'accueil est un résumé condensé de toutes les pages résumant soit pour les prestataires ces informations, soit pour nous de voir un peu de manière globale l'activité de chacun.<br/>"+
                "On peut ensuite gérer les transactions (les commandes sont gérés par les prestataires) et voir les commandes, en cours, terminées ou bien voir toutes les commandes.<br/>"+
                "Nous avons aussi des statistiques globales (pas visible ici, car ce sont des données sensibles) permettant pour l'entreprise Mantaria Studio de chiffrer son activité, de voir les prestataires et les clients les plus actifs...etc.<br/>",
        },
        image: "assets/portfolio/dashboard/dashboard.jpg",
        language: [<IconBrandReact />],
        tagSelected: ['all', 'web']
    },
    {
        title: "Création entreprise - Ratatouille",
        description: "Création d'un dossier de création d'entreprise fictif pour l'entreprise Ratatouille. Ce dossier contient un business plan, un plan de financement, un plan de trésorerie, un plan de développement, un plan de communication, un plan de production, un plan de ressources humaines, un plan juridique et un plan de gestion des risques.",
        tags: [
            {
                title:"Webdesign",
                icon: <IconBrandFigma width={20} height={20}/>
            },
            {
                title:"Gestion d'entreprise",
                icon: <IconBook width={20} height={20}/>
            },
            ],
        detailsProjects: {
            color: "#f27059",
            context: "Dans le cadre de mes études, j'ai dû réaliser un dossier de création d'entreprise fictif. Le but était de créer une entreprise de notre choix et de réaliser un dossier complet sur celle-ci.<br/>",
            technologieUsed: [
                {
                    title: "Figma",
                    icon: <IconBrandFigma width={20} height={20}/>
                }
                ],
            carousel: ["assets/portfolio/webdesign/ratatouille/Page-accueil-ratatouille.png"],
            description: "Dans le cadre de mes études, j'ai dû réaliser un dossier de création d'entreprise fictif. Le but était de créer une entreprise de notre choix et de réaliser un dossier complet sur celle-ci.<br/>"+
            "J'ai donc choisi de créer une entreprise de livraison de repas à domicile. J'ai donc réalisé un dossier complet sur cette entreprise, avec un business plan, un plan de financement, un plan de trésorerie, un plan de développement, un plan de communication, un plan de production, un plan de ressources humaines, un plan juridique et un plan de gestion des risques.<br/>"+
            "Mais j'ai aussi réalisé un design et une ergonomie simple et efficace.<br/>",
        },
        image: "assets/portfolio/webdesign/ratatouille/Page-accueil-ratatouille.png",
        language: [<IconBrandFigma />],
        tagSelected: ['all', 'design', "web"]
    },
    {
        title: "Projet Hackathon - Unity",
        description: "Dans le cadre de mes études, j'ai participé à un hackathon. Le but était de réaliser un projet autour de l'accessibilité par le web.",
        tags: [
            {
                title:"Figma",
                icon: <IconBrandFigma width={20} height={20}/>
            },
            ],
        detailsProjects: {
            color: "#f27059",
            context: "\"Actuellement, les personnes en situation de handicap n'ont pas les mêmes visions que nous sur le web. Nous avons donc réalisé un projet qui intégre un logiciel déjà connu pour de l'accessibilité (via un menu permettant de mieux percevoir les couleurs, suivre les lignes outil règle...etc).<br/>" +
                "Notre objectif était de trouver une solution à cela, toutes les manières et les réflexions sont autorisées.",
            technologieUsed: [
                {
                    title: "Figma",
                    icon: <IconBrandFigma width={20} height={20}/>
                },
                ],
            carousel: ["assets/portfolio/webdesign/hackathon/Home.png", "assets/portfolio/webdesign/hackathon/Contact.png", "assets/portfolio/webdesign/hackathon/Nos-actions.png", "assets/portfolio/webdesign/hackathon/Nos-temoignages.png", "assets/portfolio/webdesign/hackathon/Details-temoignages.png", "assets/portfolio/webdesign/hackathon/Detail-faire-un-don.png", "assets/portfolio/webdesign/hackathon/Détails-temoignages-Accessibilite.png"],
            description: "Nous avons décidé de proposer un site permettant de mettre en avant des témoignages, des histoires de personnes en situation de handicap."+
                "Si une personne était conquise par son histoire, un lien lui permettant de faire une donation à cette personne.<br/>"+
                "Nous avons donc créer une pseudo association qui permet de faire le lien entre les personnes en situation de handicap et les personnes qui veulent faire des dons.<br/>"+
                "En plus de cela, nous avons trouvé sur internet plusieurs logiciels déjà existant pour de l'accessibilité. Nous avons donc intégré ces logiciels dans notre site web.",
        },
        image: "assets/portfolio/webdesign/hackathon/Nos-actions.png",
        language: [<IconBrandFigma />],
        tagSelected: ['all', 'design', "web"]
    }
];